import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  formatJoinDate,
  getDisplayName,
  getInitials,
  type UserProfile,
} from "../utils";
import { ProfileSettingsDialog } from "./profile-settings-dialog";
import { SocialLinks } from "./social-links";

type ProfileHeaderProps = {
  profile: UserProfile;
};

export function ProfileHeader({ profile }: ProfileHeaderProps) {
  const displayName = getDisplayName(profile);

  return (
    <div className="flex flex-col items-center gap-[18px] sm:flex-row sm:items-end">
      {/* Avatar */}
      <Avatar className="h-24 w-24 rounded-[12px] border-[#0C0D0E] border-[3px] bg-gradient-to-br from-[#F5A23E] to-[#c96f1c]">
        <AvatarImage
          alt={displayName}
          className="rounded-[9px]"
          src={profile.imageUrl}
        />
        <AvatarFallback className="rounded-[12px] bg-transparent font-bold font-heading text-3xl text-[#0a0b0c]">
          {getInitials(displayName)}
        </AvatarFallback>
      </Avatar>

      {/* User Info */}
      <div className="text-center sm:pb-1.5 sm:text-left">
        <h1 className="font-bold font-heading text-2xl text-[#EAEBEC] leading-none tracking-wide sm:text-[30px]">
          {displayName}
        </h1>
        <div className="mt-2 flex flex-wrap items-center justify-center gap-2 font-mono text-[#6a7075] text-xs tracking-wider sm:justify-start">
          {profile.username ? (
            <>
              <span className="text-[#A9AFB3]">@{profile.username}</span>
              <span>·</span>
            </>
          ) : null}
          <span>
            ENLISTED {formatJoinDate(profile.stats.joinedAt).toUpperCase()}
          </span>
        </div>

        <div className="mt-3 flex flex-wrap items-center justify-center gap-3 sm:justify-start">
          <SocialLinks profile={profile} />
          <ProfileSettingsDialog profile={profile} />
        </div>
      </div>
    </div>
  );
}
